import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

const Helpers = {
  CallApi: function (
    config: AxiosRequestConfig,
    OnSuccess: (response: AxiosResponse<any>) => void,
    OnError: (msg: string, data: any) => void
  ) {
    axios(config)
      .then((response) => {
        // handle success
        if (
          response.statusText === "OK" ||
          (response.status >= 200 && response.status < 300)
        ) {
          OnSuccess(response);
        }
      })
      .catch((error) => {
        // handle error
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(
            "ERROR-RESPONSE-DATA : " + JSON.stringify(error.response.data)
          );
          console.log("ERROR-RESPONSE-STATUS : " + error.response.status);
          console.log(
            "ERROR-RESPONSE-HEADERS : " + JSON.stringify(error.response.headers)
          );
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log("ERROR-REQUEST : " + JSON.stringify(error.request));
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("ERROR : ", error.message);
        }
        console.log("ERROR-CONFIG : " + JSON.stringify(error.config));
        console.log(error);

        const responseMessage = error?.response?.data?.message
          ? " - " + error?.response?.data?.message
          : "";

        const message = error.message + responseMessage;

        OnError(message, error.response?.data);
      })
      .then(() => {
        // always executed
      });
  },
};

export default Helpers;
